// import 'react-pdf/dist/esm/Page/TextLayer.css';
// import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
// import React, {
//   useState,
//   useCallback,
//   useEffect,
//   Fragment,
//   useRef,
// } from "react";
// import { Document, Page, pdfjs } from "react-pdf";
// import "react-pdf/dist/esm/Page/AnnotationLayer.css";
// import "react-pdf/dist/esm/Page/TextLayer.css";
// import Button from "../button";
// import RightArrowIcon from "../../icons/rightArrow";
// import { useAxiosPrivate } from "../../hooks/useAxiosPrivate";
// import { format } from "date-fns";
// import { useUpdateNDA } from "../../hooks/updateNDA";
// import styles from "./style.module.css";

// // Set up PDF.js worker
// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

// const NdaDoc = ({ setIsNDAAccepted }) => {
//   const axiosPrivate = useAxiosPrivate();
//   const [isChecked, setIsChecked] = useState(false);
//   const [error, setError] = useState(false);
//   const [userData, setUserData] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [numPages, setNumPages] = useState(null);
//   const [docWidth, setDocWidth] = useState(0);
//   const updateNDA = useUpdateNDA();
//   const pdfContainerRef = useRef(null);

//   // PDF event handlers
//   const onDocumentLoadSuccess = ({ numPages }) => {
//     setNumPages(numPages);
//   };

//   const onDocumentLoadError = (error) => {
//     console.error("PDF load error:", error);
//   };

//   const handleCheckboxChange = () => {
//     setIsChecked(!isChecked);
//     setError(false);
//   };

//   const handleContinue = () => {
//     if (isChecked) {
//       setError(false);
//       handleAcceptNda();
//     } else {
//       setError(true);
//     }
//   };

//   const handleAcceptNda = useCallback(async () => {
//     try {
//       let url = `/user/accept-nda`;
//       let options = {
//         method: "POST",
//         url,
//       };
//       await axiosPrivate(options)
//         .then((response) => {
//           if (response.data.status === 1) {
//             setIsNDAAccepted(false);
//             updateNDA(response);
//           }
//         })
//         .catch((err) => {
//           if (err.response) {
//           }
//         });
//     } catch (error) {
//       // console.log(error);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const fetchUserData = useCallback(async () => {
//     try {
//       let url = `user/profile`;
//       let options = {
//         method: "GET",
//         url,
//       };
//       await axiosPrivate(options)
//         .then((response) => {
//           if (response.data.status === 1) {
//             setUserData({
//               name: response.data.user.name,
//               email: response.data.user.email,
//             });
//             setLoading(false);
//           }
//         })
//         .catch((err) => {
//           if (err.response) {
//             // console.error('err.res', err.response.data);
//           }
//         });
//     } catch (error) {
//       // console.error('error', error);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   useEffect(() => {
//     fetchUserData();
//   }, [fetchUserData]);

//   useEffect(() => {
//     const updateDocWidth = () => {
//       if (pdfContainerRef.current) {
//         setDocWidth(pdfContainerRef.current.clientWidth);
//       }
//     };

//     updateDocWidth();

//     window.addEventListener("resize", updateDocWidth);
//     return () => {
//       window.removeEventListener("resize", updateDocWidth);
//     };
//   }, []);

//   return (
//     <div className={styles.main}>
//       <div className={styles.main_container}>
//         <div className={styles.mc_content}>
//           <div className={styles.pdf_container} ref={pdfContainerRef}>
//             <Document
//               file={require("../../assets/files/DashBook-NDA.pdf")}
//               onLoadSuccess={onDocumentLoadSuccess}
//               onLoadError={onDocumentLoadError}
//               loading=""
//             >
//               {Array.from(new Array(numPages), (el, index) => (
//                 <Page
//                   key={`page_${index + 1}`}
//                   pageNumber={index + 1}
//                   scale={1.0}
//                   // width={docWidth || 500}
//                   width={window.innerWidth < 768 ? window.innerWidth - 30 : docWidth || 500}
//                   renderTextLayer={false}
//                   renderAnnotationLayer={false}
//                 />
//               ))}
//             </Document>
//           </div>
//           {!loading && (
//             <Fragment>
//               <div className={styles.mc_user_info}>
//                 <div className={styles.mc_user_info_item}>
//                   <span>Name</span>
//                   <strong>{userData.name}</strong>
//                 </div>
//                 <div className={styles.mc_user_info_item}>
//                   <span>Email</span>
//                   <strong>{userData.email}</strong>
//                 </div>
//                 <div className={styles.mc_user_info_item}>
//                   <span>Date</span>
//                   <strong>{format(new Date(), "dd MMM yyyy")}</strong>
//                 </div>
//               </div>
//               <div className={styles.mc_footer}>
//                 <div className={styles.mc_clabel}>
//                   <label>
//                     <input
//                       type="checkbox"
//                       checked={isChecked}
//                       onChange={handleCheckboxChange}
//                     />
//                     <span>
//                       I acknowledge I have read and understood the terms of
//                       Privacy Policy and Terms and Conditions.
//                     </span>
//                   </label>
//                 </div>
//                 {error ? (
//                   <div className={styles.mc_error}>
//                     <span>Please check the NDA.</span>
//                   </div>
//                 ) : null}
//                 <div className={styles.mc_button}>
//                   <Button
//                     title="Continue"
//                     endIcon={<RightArrowIcon />}
//                     onClick={handleContinue}
//                     disabled={!isChecked}
//                   />
//                 </div>
//               </div>
//             </Fragment>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default NdaDoc;


import React, { useState, useCallback, useEffect, Fragment } from "react";
import Button from "../button";
import RightArrowIcon from "../../icons/rightArrow";
import { useAxiosPrivate } from "../../hooks/useAxiosPrivate";
import { format } from "date-fns";
import { useUpdateNDA } from "../../hooks/updateNDA";
import styles from "./style.module.css";

const NdaDoc = ({ setIsNDAAccepted }) => {
  const axiosPrivate = useAxiosPrivate();
  const [isChecked, setIsChecked] = useState(false);
  const [error, setError] = useState(false);
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(true);
  const updateNDA = useUpdateNDA();

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    setError(false);
  };

  const handleContinue = () => {
    if (isChecked) {
      setError(false);
      handleAcceptNda();
    } else {
      setError(true);
    }
  };

  const handleAcceptNda = useCallback(async () => {
    try {
      let url = `/user/accept-nda`;
      let options = {
        method: "POST",
        url,
      };
      await axiosPrivate(options)
        .then((response) => {
          if (response.data.status === 1) {
            setIsNDAAccepted(false);
            updateNDA(response);
          }
        })
        .catch((err) => {
          if (err.response) {
          }
        });
    } catch (error) {
      // console.log(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchUserData = useCallback(async () => {
    try {
      let url = `user/profile`;
      let options = {
        method: "GET",
        url,
      };
      await axiosPrivate(options)
        .then((response) => {
          if (response.data.status === 1) {
            setUserData({
              name: response.data.user.name,
              email: response.data.user.email,
            });
            setLoading(false);
          }
        })
        .catch((err) => {
          if (err.response) {
            // console.error('err.res', err.response.data);
          }
        });
    } catch (error) {
      // console.error('error', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  return (
    <div className={styles.main}>
      <div className={styles.main_container}>
        <div className={styles.mc_content}>
          <div className={styles.pdf_container}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', alignItems: 'center', width: '100%' }}>
              <img
                src={require("../../assets/files/nda-page-1.jpg")}
                alt="DashBook NDA Page 1"
                style={{ width: '100%', maxWidth: '800px', boxShadow: '0px 4px 12px rgba(0,0,0,0.1)' }}
              />
              <img
                src={require("../../assets/files/nda-page-2.jpg")}
                alt="DashBook NDA Page 2"
                style={{ width: '100%', maxWidth: '800px', boxShadow: '0px 4px 12px rgba(0,0,0,0.1)' }}
              />
            </div>

          </div>
          {!loading && (
            <Fragment>
              <div className={styles.mc_user_info}>
                <div className={styles.mc_user_info_item}>
                  <span>Name</span>
                  <strong>{userData.name}</strong>
                </div>
                <div className={styles.mc_user_info_item}>
                  <span>Email</span>
                  <strong>{userData.email}</strong>
                </div>
                <div className={styles.mc_user_info_item}>
                  <span>Date</span>
                  <strong>{format(new Date(), "dd MMM yyyy")}</strong>
                </div>
              </div>
              <div className={styles.mc_footer}>
                <div className={styles.mc_clabel}>
                  <label>
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                    />
                    <span>
                      I acknowledge I have read and understood the terms of
                      Privacy Policy and Terms and Conditions.
                    </span>
                  </label>
                </div>
                {error ? (
                  <div className={styles.mc_error}>
                    <span>Please check the NDA.</span>
                  </div>
                ) : null}
                <div className={styles.mc_button}>
                  <Button
                    title="Continue"
                    endIcon={<RightArrowIcon />}
                    onClick={handleContinue}
                    disabled={!isChecked}
                  />
                </div>
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default NdaDoc;